module.exports = "/_next/static/images/0ecf027cf8fd4fffa47b31c23375292f-two-people-looking-lg@1x.jpg";